@import 'abstract/colors';
@import 'abstract/variables';

quick-product-search {
.quick-product-search {
  display: flex;
  width: 100%;
  max-width: 90%;
  margin: 0 auto;

  @include breakpoint(md) {
    max-width: none;
    margin: 0;
  }

  &__input {
    font-size: 13px;
    z-index: 21;
    box-sizing: border-box;
    width: 100%;
    height: 37px;
    padding: 0 15px;
    border: 1px solid $sky-blue;
    border-radius: 4px 0 0 4px;
    outline: none;
    background: #ffffff;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    @include breakpoint(md) {
      height: 45px;
      border: 0;
      border-radius: 0;
    }

    @include breakpoint(sm) {
      font-size: 14px;
    }

    &::placeholder {
      color: var(--quick-product-palceholder-text-color);

      @include breakpoint(sm) {
        font-size: 14px;
      }
    }
  }

  &__button {
    font-size: 16px;
    z-index: 21;
    width: 40px;
    height: 37px;
    margin-left: -1px;
    color: #ffffff;
    border: 1px solid var(--quick-product-search-button);
    border-radius: 0 2px 2px 0;
    background: var(--quick-product-search-button);

    @include breakpoint(md) {
      min-width: 45px;
      height: 45px;
      border-radius: 0;
    }

    i:before {
      font-family: 'icomoon';
      font-style: normal;
      content: "\f002";
    }
  }
}
}
